import type { ComponentProps } from 'react';
import React from 'react';
import type { MarginRightProps } from 'styled-system';

import { Flex } from 'common/components/Flex';
import type { IconName } from 'common/components/Icon';
import Icon, { DEFAULT_ICON_SIZE } from 'common/components/Icon';
import { CaptionRegularCR1 } from 'common/components/Typography';

interface MicroUspItemProps extends MarginRightProps {
  iconName: IconName;
  label: string;
}

const containerStyles: ComponentProps<typeof Flex> = {
  as: 'figure',
  alignItems: 'center',
  m: 'sp_0',
};

const iconStyles: Partial<ComponentProps<typeof Icon>> = {
  size: DEFAULT_ICON_SIZE,
  color: 'sys.neutral.icon.default',
};

const captionStyles: ComponentProps<typeof CaptionRegularCR1> = {
  as: 'figcaption',
  ml: 'sp_4',
};

const MicroUspItem = ({ iconName, label, mr }: MicroUspItemProps) => (
  <Flex {...containerStyles} mr={mr}>
    <Icon {...iconStyles} name={iconName} dataTestId={`${iconName}-icon`} />
    <CaptionRegularCR1 dangerouslySetInnerHTML={{ __html: label }} {...captionStyles} />
  </Flex>
);

export default MicroUspItem;
